module.exports = __webpack_public_path__ + "static/img/1.4499887.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/2/eng/1.png
// module id = 1d8P
// module chunks = 0